import { useEffect } from 'react';
import { getCountryList } from './Reducers/Country/Actions';
import { globalLoaderStateManager } from './GlobalLoader';
import { useDispatch, useSelector } from 'react-redux';
const { watchPromise } = globalLoaderStateManager;

export const CountryContainer = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    watchPromise(dispatch(getCountryList()));
  }, [dispatch]);
  const { countries } = useSelector((state) => state.Country);
  return countries.length ? children : null;
};

export default CountryContainer;
